import React from 'react';
import UserPortal from './UserPortal';

function App() {
  return <UserPortal />;
}

export default App;